"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddressCoder = void 0;
const address_1 = require("@ethersproject/address");
const bytes_1 = require("@ethersproject/bytes");
const web3_utils_1 = require("@theqrl/web3-utils");
const abstract_coder_1 = require("./abstract-coder");
class AddressCoder extends abstract_coder_1.Coder {
    constructor(localName) {
        super("address", "address", localName, false);
    }
    defaultValue() {
        return "Z0000000000000000000000000000000000000000";
    }
    encode(writer, value) {
        try {
            value = (0, address_1.getAddress)((0, web3_utils_1.addressToHex)(value));
        }
        catch (error) {
            this._throwError(error.message, value);
        }
        return writer.writeValue(value);
    }
    decode(reader) {
        return (0, web3_utils_1.hexToAddress)((0, address_1.getAddress)((0, bytes_1.hexZeroPad)(reader.readValue().toHexString(), 20)));
    }
}
exports.AddressCoder = AddressCoder;
//# sourceMappingURL=address.js.map